module.exports = __webpack_public_path__ + "media/certifications/laptop-and-phone-940072b1.webp";